import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';

import styles from './Footer.module.css';

const footerIcons = [
  {
    id: 1,
    image: require('./img/icons/explore.png'),
    activeImage: require('./img/icons/explore-hover.png'),
    label: 'EXPLORE'
  },
  {
    id: 2,
    image: require('./img/icons/saved.png'),
    activeImage: require('./img/icons/saved-hover.png'),
    label: 'SAVED'
  },
  {
    id: 3,
    image: require('./img/icons/trips.png'),
    activeImage: require('./img/icons/trips-hover.png'),
    label: 'TRIPS'
  },
  {
    id: 4,
    image: require('./img/icons/inbox.png'),
    activeImage: require('./img/icons/inbox-hover.png'),
    label: 'INBOX'
  },
  {
    id: 5,
    image: require('./img/icons/profile.png'),
    activeImage: require('./img/icons/profile-hover.png'),
    label: 'PROFILE'
  }
]

class Seats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tripAdded: false,
      activeIndex: 0
    };
  }

  componentDidMount(){
    if (this.props.location.pathname === '/flights/confirmation'){
      this.setState({ tripAdded: true });
    }
  }
  
  render() {
    return (
      <footer className={(this.state.tripAdded ? styles.hasTrip : '')}>
        {footerIcons.map((icon, index) => {
          const isActive = this.state.activeIndex === index;
          return(
            <Link onClick={() => { this.setState({ activeIndex: index }) }} key={index} to={`/`}> 
              <img src={isActive ? icon.activeImage : icon.image}/>
              {this.state.tripAdded && index === 2 ? <div className={styles.tripAdded}>&nbsp;</div> : null}
              <p className={isActive ? styles.activeText : null}>{icon.label}</p>
            </Link>
          )
        })}
      </footer>
    );
  }
}

export default withRouter(Seats);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx